import {CSSProperties, useEffect, useState} from "react";
import {ScoreAlert} from "@components/alerts/ScoreAlert";
import {AchievementAlert} from "@components/alerts/AchievementAlert";
import {Game} from "@game/game";
import {GameEvent} from "@game/gameEvent";
import {HighScoreAlert} from "@components/alerts/HighScoreAlert";
import {connect} from "react-redux";
import {selectDialog} from "@redux/selectors/dialog";
import Dialog, {IDialog} from "@redux/slices/dialog";

const DebugScoreAlert = {
    data: {
        count: 1,
        placedScore: 1,
        score: 2,
        word: "the",
        wordScore: 1
    },
    type: "ScoreAlert"
};

const DebugHighScoreAlert = {
    data: {
        nickname: "alex_1",
        score: 2,
        type: "daily",
        words: [{
            score: 2,
            word: "the"
        }]
    },
    type: "HighScoreAlert"
};

const styles: Record<string, CSSProperties> = {
    content: {
    }
};
export interface IAlert {
    type: string
    data: any
}
interface IAlerts {
    dialog: IDialog
    game: Game
    ready: boolean
}

function Alerts({dialog, game, ready}: IAlerts) {
    const [alerts, setAlerts] = useState<IAlert[]>([]);
    const [currentAlert, setCurrentAlert] = useState<IAlert>();
    const handleClose = () => {
        setCurrentAlert(undefined);
        return alerts.length === 0;
    }

    useEffect(() => {
        if (ready && alerts.length && currentAlert === undefined && dialog.name !== "") {
            setCurrentAlert(alerts[0]);
            setAlerts(alerts.slice(1));
        }
    }, [alerts, currentAlert, dialog, ready]);
    useEffect(() => {
        const handleGameEvent = (event: GameEvent) => {
            if (event.type === "PlayerScored") {
                setAlerts(alerts => [
                    ...alerts,
                    ...event.properties.words.map((word: any) => ({
                        type: "ScoreAlert",
                        data: word
                    }))
                ]);
            } else if (event.type === "NewHighScore") {
                setAlerts(alerts => [
                    ...alerts,
                    {
                        type: "HighScoreAlert",
                        data: event.properties
                    }
                ]);
            } else if (event.type === "AchievementsUnlocked") {
                setAlerts(alerts => [
                    ...alerts,
                    ...(event.properties.ids as Array<{ id: string; name: string; description: string }>).map(a => ({
                        type: "AchievementAlert",
                        data: a
                    }))
                ]);
            }
        };

        game.events.delegates.add(handleGameEvent);
        return () => game.events.delegates.remove(handleGameEvent)
    }, [game]);
    if (! currentAlert) return null;
    return (
        <div style={styles.content}>
            {currentAlert.type === "ScoreAlert" &&
                <ScoreAlert alert={currentAlert} game={game} onClose={handleClose}/>}
            {currentAlert.type === "HighScoreAlert" &&
                <HighScoreAlert alert={currentAlert} game={game} onClose={handleClose}/>}
            {currentAlert.type === "AchievementAlert" &&
                <AchievementAlert alert={currentAlert} onClose={handleClose}/>}
        </div>
    );
}
const mapStateToProps = () => ({
    dialog: selectDialog
});
const connected = connect(mapStateToProps, {
})(Alerts);
export {connected as Alerts}
